<template>
    <div class="loading" :class="{'loading--fullscreen': fullscrean}">
      <div class="loading__content">
        <div class="loading__spinner" aria-hidden="true"></div>
        <div class="loading__text" v-show="text">{{text}}</div>
      </div>
    </div>
</template>

<script>
    export default {
      name: "loading",
      props: ['fullscrean', 'text']
    }
</script>

<style scoped>
.loading {
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 20px 0;
}

.loading--fullscreen {
  position: absolute;
  inset: 0;
  z-index: 20;
  align-items: center;
  padding: 24px;
}

.loading__content {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.loading__spinner {
  width: 30px;
  height: 30px;
  border-radius: 999px;
  border: 3px solid rgba(30, 51, 108, 0.12);
  border-top-color: var(--primary);
  border-right-color: var(--secondary);
  animation: loadingSpin 0.9s linear infinite;
}

.loading__text {
  margin-top: 12px;
  font-size: 13px;
  font-weight: 700;
  color: var(--text-theme-secondary);
  text-align: center;
  }

.dark-mode .loading__spinner {
  border-color: rgba(124, 181, 230, 0.16);
  border-top-color: var(--primary);
  border-right-color: var(--secondary);
  }

  @keyframes loadingSpin {
    to {
      transform: rotate(360deg);
    }
  }
</style>
